import getIntention from './utils/getIntention';
import getMappedAction from './utils/getMappedAction';
import getRemainingCdlData from './utils/getRemainingCdlData';

const SPECIALS_EVENT_PERSONALIZATION = {
	'CVRE recommended vehicles': 'cvre',
	'WIS recommended vehicles': 'wis',
	'Featured vehicles': 'featured',
	'New arrival vehicles': 'new arrivals'
};

const mapWUE = ({ eventData }) => {
	const { element, elementCTA, mywallet, result, vehicle, widgetName } =
		eventData;

	const payload = {
		event: {
			element: typeof element === 'string' ? element : '',
			elementText: elementCTA,
			category: 'widgetUserEvent',
			action: getMappedAction(eventData),
			myWalletFlag: typeof mywallet === 'boolean' ? mywallet : null,
			personalization:
				widgetName === 'ws-rec-vehicles'
					? SPECIALS_EVENT_PERSONALIZATION[element]
					: null,
			...getIntention(result),
			...getRemainingCdlData(eventData)
		}
	};

	if (payload.event.vehicle) {
		payload.event.vehicle = {
			...payload.event.vehicle,
			listingType: vehicle?.listingType || 'standard'
		};
	}

	return payload;
};

export default {
	events: {
		'ddc.form.confirmation': [
			{
				payload: ({ eventData }) => {
					// Build the base event object
					const eventPayload = {
						element: 'lead',
						action: 'submit',
						id: eventData.eventId,
						conversionType: 'form',
						conversionInstanceId: eventData.formEventId,
						formType: eventData.formType,
						nonProductionData: true,
						pixallMigrationId: eventData.eventId
					};

					// Conditionally add vehicle data if vehicleId exists
					if (eventData.vehicleId) {
						eventPayload.vehicle = {
							vin: eventData.vin || '',
							dealerStockNumber: eventData.stockNumber || '',
							exteriorColor: eventData.exteriorColor || '',
							id: eventData.vehicleId,
							type: eventData.vehicleType || '',
							listingAccountId: eventData.listingCode || ''
						};
					}

					return {
						event: eventPayload,
						user: {
							emailAddress:
								eventData.cdl?.user?.emailAddress || ''
						}
					};
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: [
					({ eventData }) =>
						eventData.attributes?.href?.includes('/esntial.htm')
				],
				payload: ({ eventData }) => ({
					event: {
						action: 'click',
						element: 'CTA Button/Link',
						elementText: eventData.text,
						destinationUrl: eventData.attributes?.href
					}
				})
			}
		],
		widgetUserEvent: [
			{
				logic: ({ eventData: { widgetName, element, result } }) =>
					(widgetName === 'ws-inv-text-search' &&
						result === 'form submitted') ||
					(widgetName === 'ws-site-text-search' &&
						element === 'search query typed in'),
				payload: ({ eventData }) => {
					const basePayload = mapWUE({ eventData });
					return {
						...basePayload,
						event: {
							...basePayload.event,
							search: {
								keywords: eventData.fieldValue || ''
							}
						}
					};
				}
			},
			{
				// Catch-all for widgetUserEvents that are not captured above
				payload: mapWUE
			}
		],
		thirdPartyUserEvent: {
			payload: ({ eventData }) => {
				const { elementCTA, mywallet, product, result, step } =
					eventData;

				return {
					event: {
						element: `${product} ${step}` || '',
						elementText: elementCTA,
						category: 'thirdPartyUserEvent',
						action: getMappedAction(eventData),
						myWalletFlag:
							typeof mywallet === 'boolean' ? mywallet : null,
						...getIntention(result),
						...getRemainingCdlData(eventData)
					}
				};
			}
		},
		specialsEvent: {
			payload: ({ eventData }) => {
				const {
					elementCTA,
					mywallet,
					result,
					specialCategory,
					specialPersonalized,
					specialPlacementType,
					title
				} = eventData;

				const specialsEventElement = (
					specialCategory ||
					title ||
					''
				).toLowerCase();

				return {
					event: {
						elementText: elementCTA,
						category: 'specialsEvent',
						action: getMappedAction(eventData),
						element: specialsEventElement,
						location: specialPlacementType,
						myWalletFlag:
							typeof mywallet === 'boolean' ? mywallet : null,
						personalization: specialPersonalized ? 'yes' : null,
						...getIntention(result),
						...getRemainingCdlData(eventData)
					}
				};
			}
		}
	}
};
